import { createFileRoute } from '@tanstack/react-router';
import { staticAgencyData } from '../agency';

export const Route = createFileRoute('/_private-routes/agency/add')({
  staticData: staticAgencyData
});
